function normaliseValue(value = '') {
  return String(value || '')
    .trim()
    .toLowerCase()
}

function shouldAutoRollCombatant(combatant, config = {}) {
  const type = normaliseValue(combatant?.type)
  const category = normaliseValue(combatant?.category)

  if (type === 'troop') {
    return config.auto_sr_roll_troops === true
  }

  if (type === 'character') {
    return config.auto_sr_roll_chars === true
  }

  if (type === 'npc') {
    return config.auto_sr_roll_npcs === true
  }

  if (type === 'monster') {
    return config.auto_sr_roll_monsters === true
  }

  // Fall back to party-aligned rows where legacy data omitted the explicit type.
  if (!type && category === 'party') {
    return config.auto_sr_roll_chars === true
  }

  return false
}

//------------------------
// auto roll combatant srs
//------------------------
export default function autoRollCombatantSRs(combatants, config = {}) {
  combatants
    .filter(
      (combatant) =>
        normaliseValue(combatant?.status) === 'active' &&
        shouldAutoRollCombatant(combatant, config),
    )
    .forEach((combatant) => {
      if (combatant.sr_roll == 0) {
        combatant.sr_roll = Math.floor(Math.random() * 10) + 1
      }
    })

  return combatants
}
